import React from 'react';

function AddFilterButton({
  onClick,
  disabled = false,
  ariaExpanded,
  ariaControls,
  className = '',
}) {
  const baseClassName = 'btn btn-outline-secondary btn-sm d-inline-flex align-items-center gap-1';
  const mergedClassName = className ? `${baseClassName} ${className}` : baseClassName;

  return (
    <button
      type="button"
      className={mergedClassName}
      onClick={onClick}
      disabled={disabled}
      aria-expanded={ariaExpanded}
      aria-controls={ariaControls}
    >
      <i className="fal fa-plus" aria-hidden="true" />
      <span>Add filter</span>
    </button>
  );
}

export default AddFilterButton;
